define('v3/Pages/Check/Components/CheckClassGrid/Services/checkClassGrid.Backend',[
	'jquery',
	'module',
	'BackendBase'
], function ($, module, BackendBase) {
	function CheckClassBackend () {
		BackendBase.call(this);
	};

	CheckClassBackend.prototype = $.extend({}, BackendBase.prototype);

	$.extend(CheckClassBackend.prototype, {

		getAbilityGrowthForSubjectGroup: function (subjectGroupId, period, usePupilAverageGrowth) {
			if (usePupilAverageGrowth) {
				var url = Settings.metricsApi;
				return this._getJsonApiWithJwtAuthorization(url + '/Growth/' + subjectGroupId + '/Pupils', { period: period }, { showError: false });
			} else {
				return this._getJsonApi('SubjectGroupAbilityGrowth/' + subjectGroupId + '/Pupils', { period: period });
			}
		},

		getAbilityGrowthForPupil: function (pupilId, subjectGroupId, period) {
			return this._getJsonApi('SubjectGroupAbilityGrowth/' + subjectGroupId + '/Pupils/' + pupilId, { period: period });
		},

		getSubjectCurrentPercentileForPupilsInSubjectGroup: function (subjectGroupId) {
			return this._getJsonApi('Boundaries/' + subjectGroupId + '/SubjectCurrentPercentileForPupilsInSubjectGroup');
		},

		getSubdomainsWithBoundaryPercentileForPupils: function (subjectGroupId) {
			return this._getJsonApiWithJwtAuthorization(this._getApiUrl('Subdomains/' + subjectGroupId + '/SubdomainsWithBoundaryPercentileForSubjectGroup'));
		},

		getSubjectGroupAbilityHistory: function (subjectGroupId) {
			return this._getJsonApi('AbilityGraph/GetSubjectGroupAbilityHistory/' + subjectGroupId);
		},

		getNumberOfExtraInstructionsForSubdomainsForPupils: function (subjectGroupId) {
			return this._getJsonApiWithJwtAuthorization(this._getApiUrl('ExtraInstructions/NumberOfExtraInstructionsForSubdomains/' + subjectGroupId));
		},

		UserSubjectTargetPercentileForSubjectGroup: function (subjectGroupId) {
			return this._getJsonApi('Boundaries/UserSubjectTargetPercentileForSubjectGroup/' + subjectGroupId);
		},

		generateReport: function (html) {
			return this._postJsonApi('PupilsReport/GeneratePdf', { html: html });
		}
	});

	return new CheckClassBackend();
});

